import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = ({ activeItem, userRole, show, onClose }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const handleLinkClick = () => {
    // Close sidebar on mobile when a link is clicked
    if (onClose && window.innerWidth < 992) {
      onClose();
    }
  };

  const adminMenuItems = [
    { key: 'dashboard', icon: 'fas fa-tachometer-alt', label: 'Dashboard', path: '/admin' },
    { key: 'employees', icon: 'fas fa-users', label: 'Employees', path: '/admin/employees' },
    { key: 'create-employee', icon: 'fas fa-user-plus', label: 'Create Employee', path: '/admin/create-employee' },
    { key: 'leave-requests', icon: 'fas fa-calendar-check', label: 'Leave Requests', path: '/admin/leave-requests' },
    { key: 'permissions', icon: 'fas fa-user-clock', label: 'Permissions', path: '/admin/permissions' },
    { key: 'claims', icon: 'fas fa-receipt', label: 'Claims', path: '/admin/claims' },
    { key: 'attendance', icon: 'fas fa-clock', label: 'Attendance', path: '/admin/attendance' },
    { key: 'refreshments', icon: 'fas fa-coffee', label: 'Refreshments', path: '/admin/refreshments' },
    { key: 'payslip', icon: 'fas fa-file-invoice-dollar', label: 'Payslip', path: '/admin/payslip' },
    { key: 'task-reports', icon: 'fas fa-tasks', label: 'Task Reports', path: '/admin/task-reports' },
    { key: 'create-task', icon: 'fas fa-clipboard-list', label: 'Create Task', path: '/admin/create-task' },
    { key: 'assign-task', icon: 'fas fa-user-check', label: 'Assign Task', path: '/admin/assign-task' },
    // { key: 'reports', icon: 'fas fa-chart-bar', label: 'Reports', path: '/admin/reports' },
    // { key: 'settings', icon: 'fas fa-cog', label: 'Settings', path: '/admin/settings' }
  ];

  const employeeMenuItems = [
    { key: 'dashboard', icon: 'fas fa-tachometer-alt', label: 'Dashboard', path: '/employee' },
    { key: 'leave-request', icon: 'fas fa-calendar-plus', label: 'Request Leave', path: '/employee/leave-request' },
    { key: 'my-requests', icon: 'fas fa-list', label: 'My Requests', path: '/employee/my-requests' },
    { key: 'permission-request', icon: 'fas fa-user-clock', label: 'Request Permission', path: '/employee/permission-request' },
    { key: 'my-permissions', icon: 'fas fa-list-check', label: 'My Permissions', path: '/employee/my-permissions' },
    { key: 'claims', icon: 'fas fa-receipt', label: 'Claims', path: '/employee/claims' },
    { key: 'my-claims', icon: 'fas fa-list-check', label: 'My Claims', path: '/employee/my-claims' },
    { key: 'attendance', icon: 'fas fa-clock', label: 'Attendance', path: '/employee/attendance' },
    { key: 'refreshments', icon: 'fas fa-coffee', label: 'Refreshments', path: '/employee/refreshments' },
    { key: 'task-submission', icon: 'fas fa-tasks', label: 'Daily Tasks', path: '/employee/task-submission' },
    { key: 'daily-task', icon: 'fas fa-clipboard-check', label: 'Daily Task', path: '/employee/daily-task' },
    { key: 'request-work', icon: 'fas fa-user-plus', label: 'Request Work', path: '/employee/request-work' },
    { key: 'profile', icon: 'fas fa-user', label: 'Profile', path: '/employee/profile' }
  ];

  const menuItems = userRole === 'admin' ? adminMenuItems : employeeMenuItems;

  return (
    <>
      {/* Overlay for mobile */}
      {show && (
        <div 
          className="sidebar-overlay d-lg-none" 
          onClick={onClose}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1039
          }}
        />
      )}
      
      <div className={`sidebar ${show ? 'show' : ''}`}>
        <div className="sidebar-header">
        <div className="d-flex align-items-center">
          <div className="me-3">
            <i className="fas fa-calendar-alt fs-3"></i>
          </div>
          <div>
            <h5 className="mb-0">HR Management</h5>
            <small className="opacity-75">Lil Humans & Havens</small>
          </div>
        </div>
      </div>

      <div className="sidebar-menu">
        {/* User Info */}
        <div className="px-3 py-2 border-bottom">
          <div className="d-flex align-items-center">
            <div className="me-3">
              <div 
                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                style={{ width: '40px', height: '40px' }}
              >
                <i className="fas fa-user"></i>
              </div>
            </div>
            <div className="flex-grow-1">
              <div className="fw-bold">{user?.firstName} {user?.lastName}</div>
              <small className="text-muted text-capitalize">{user?.role}</small>
            </div>
          </div>
        </div>

        {/* Menu Items */}
        <Nav className="flex-column">
          {menuItems.map((item) => (
            <Link 
              key={item.key} 
              to={item.path}
              className={`sidebar-item ${activeItem === item.key ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <i className={`${item.icon} me-3`}></i>
              {item.label}
            </Link>
          ))}
        </Nav>

        {/* Logout */}
        <div className="mt-auto p-3 border-top">
          <button 
            className="btn btn-outline-danger w-100"
            onClick={handleLogout}
          >
            <i className="fas fa-sign-out-alt me-2"></i>
            Logout
          </button>
        </div>
      </div>
      </div>
    </>
  );
};

export default Sidebar;